import { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';

interface Props {
  children?: ReactNode;
  isDisabled?: boolean;
  onClick?: any;
  label?: string;
  href?: any;
  target?: string;
  className?: string;
  dataProps?: any;
}

export default function Component(props: Props) {
  const dataProps = props.dataProps || {};
  return (
    <IconButton
      aria-label={props.label}
      className={props.className}
      disabled={props.isDisabled}
      target={props.target}
      onClick={props.onClick}
      href={props.href}
      {...dataProps}
    >
      {props.children}
    </IconButton>
  );
}
